export type Enum<TEnum extends object> = TEnum[keyof TEnum];

export const TENANT_SUBSCRIPTION_STATUS = {
    ACTIVE: 'active',
    IN_TRIAL: 'in_trial',
    NON_RENEWING: 'non_renewing',
    PAUSED: 'paused',
    CANCELLED: 'cancelled',
} as const;

/** @deprecated Misspelled name kept as an alias for existing consumers; use TENANT_SUBSCRIPTION_STATUS. */
export const TENANT_SUBSCRIPTIONL_STATUS = TENANT_SUBSCRIPTION_STATUS;

export type TenantSubscriptionStatus = Enum<typeof TENANT_SUBSCRIPTION_STATUS>;

/** @deprecated Misnamed (it is a status, not a plan); use TenantSubscriptionStatus. */
export type SubscriptionPlan = TenantSubscriptionStatus;
